export const PARAMETERS = 'parameters';
export const GROUP_PARAMETER_KEY = 'group';
export const GROUP_PARAMETER_OPTIONS = {
  control: 'control',
  variant: 'variant'
};

// FTS0015
export const FTS0015_TREATMENT_KEY = 'fts-0015';